import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-time-picker-modal',
  templateUrl: './time-picker-modal.component.html',
  styleUrls: ['./time-picker-modal.component.scss'],
})
export class TimePickerModalComponent implements OnInit {
  @Input() minInterval = 15;
  @Input() format = '12hr';
  @Input() minHour = 0;
  @Input() maxHour = 0;
  @Input() minMinute = 0;
  @Input() maxMinute = 0;
  @Input() minTimeMeridien;
  @Input() maxTimeMeridien;
  @Input() selectedHour;
  @Input() selectedMinute;
  @Input() selectedMeridien;
  @Input() allowMidnight = false;
  @Input() midnightSelected = false;
  meridien = 'AM';
  hourValue = 0;
  minuteValue = 0;
  cnt = 0;

  hours = '00';
  minutes = '00';
  hoursnew = '00';

  selectedField = null;

  dialPad = [];
  error = null;
  showKeypad = false;
  constructor(private modalRef: ModalController,) { }

  ngOnInit() {
    this.hourValue = this.selectedHour;//(this.maxHour > 12 ? this.maxHour - 12 : this.maxHour);
    this.minuteValue = this.selectedMinute; //this.maxMinute;
    this.meridien = this.selectedMeridien;//this.maxTimeMeridien;
    this.normalizeSelectionToInterval();
    this.hours = this.getDisplayHourKeyPad(this.hourValue);
    this.minutes = this.getDisplayMinuteKeyPad(this.minuteValue); //this.maxMinute;
    this.hoursnew = '0000';

    this.computeDial();
  }

  computeDial() {
    const dials = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];



    for (const dial of dials) {
      if (dial === 10) {
        this.dialPad.push({ number: 'toggle', method: 'toggle' });
        continue;
      }
      if (dial === 11) {
        this.dialPad.push({ number: 0, method: 'add' });
        continue;
      }
      if (dial === 12) {
        this.dialPad.push({ number: 'Reset', method: 'reset' });
        continue;
      }
      this.dialPad.push({ number: dial, method: 'add' });

    }
  }

  getValue(hour: number, minute: number, meridiem: string) {
    let result = 0;
    if (meridiem == null) {
      const hourValue = hour * 60;
      const minValue = minute;
      result = hourValue + minValue;
    }
    if (meridiem != null) {
      if (hour === 12 && meridiem === 'AM') {
        hour = 0;
      }
      else if (hour >= 12 && meridiem === 'PM') {
        hour = hour - 12
      }
      const hourValue = meridiem === 'PM' ? (12 + hour) * 60 : hour * 60;
      const minValue = minute;
      result = hourValue + minValue;
    }

    return result;

  }

  switchMeridiemKeyBoard() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    const newMedrien = (this.meridien === 'AM') ? 'PM' : 'AM';
    const newhour = +this.hours;
    const newminute = +this.minutes;
    const newValue = this.getValue(newhour, newminute, newMedrien);

    if (newValue >= hourLowerValue && newValue <= hourUpperValue) {
      this.meridien = newMedrien;
    }
  }

  switchMeridiem() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    let newMedrien = (this.meridien === 'AM') ? 'PM' : 'AM';
    let newhour = this.hourValue;
    const newminute = this.minuteValue;
    if (this.hourValue === 12 && newMedrien === 'AM') {
      newhour = 0;
      newMedrien = 'AM';
    }
    if (this.hourValue === 0 && newMedrien === 'PM') {
      newhour = 12;
      newMedrien = 'PM';
    }
    const newValue = this.getValue(newhour, newminute, newMedrien);

    if (newValue >= hourLowerValue && newValue <= hourUpperValue) {
      this.meridien = newMedrien;
      if (this.hourValue === 12 && newMedrien === 'AM') {
        this.hourValue = 0;
        this.meridien = 'AM';
        return;
      }
      if (this.hourValue === 0 && newMedrien === 'PM') {
        this.hourValue = 12;
        this.meridien = 'PM';
        return;
      }
    }
  }

  addHour() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);

    let hour = this.hourValue;
    let meridien = this.meridien;

    if (this.meridien === 'AM' && this.hourValue === 12) {
      hour = 0;
    }
    if (this.meridien === 'AM' && this.hourValue === 11) {
      hour = hour + 1;
      meridien = 'PM';
    }
    else if (this.meridien === 'PM' && this.hourValue === 12) {
      hour = 1;
    }
    else if (this.meridien === 'PM' && this.hourValue === 11) {
      hour = hour;
    }
    else {
      hour = hour + 1;
    }
    if (this.meridien === 'PM' && this.hourValue === 13) {
      hour = 1;
    }
    const newHourValue = this.getValue(hour, this.minuteValue, meridien);

    if (newHourValue >= hourLowerValue && newHourValue <= hourUpperValue) {
      hour = this.getHour(newHourValue);
      this.hourValue = hour;
      this.minuteValue = this.getMinute(newHourValue);
      this.meridien = this.getMeridiem(newHourValue);
    }

  }


  getHour(newHourValue) {
    let hour = Math.floor(newHourValue / 60);
    if (hour > 12) {
      hour = hour - 12;
    }

    return hour;
  }


  getMinute(newHourValue) {
    const minutes = newHourValue % 60;
    return minutes;
  }


  getMeridiem(newHourValue) {
    const hour = Math.floor(newHourValue / 60);
    if (hour >= 12) {
      return 'PM';
    }
    return 'AM';
  }


  reduceHour() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    if (this.meridien === 'AM' && this.hourValue === 12) {
      this.hourValue = 0;
    }

    let hour = this.hourValue;
    let meridiem = this.meridien;
    if (this.hourValue - 1 === 0 && this.meridien === 'PM') {
      meridiem = 'PM';
      hour = 12;
    }
    else if (this.hourValue - 1 === 11 && this.meridien === 'PM') {
      hour = this.hourValue - 1;
      meridiem = 'AM';
    }
    else { hour = hour - 1; }

    if (meridiem === 'PM' && hour === -1) {
      hour = (hour === -1 ? 12 : hour);
    }

    const newHourValue = this.getValue(hour, this.minuteValue, meridiem);

    if (newHourValue >= hourLowerValue && newHourValue <= hourUpperValue) {
      hour = this.getHour(newHourValue);
      this.hourValue = hour;
      this.minuteValue = this.getMinute(newHourValue);
      this.meridien = this.getMeridiem(newHourValue);
    }

  }

  validateKeyboardOutput() {
    let result = false;
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    if (this.meridien === 'AM' && this.hourValue === 12) {
      this.hourValue = 0;
    }

    let hour = +this.hours;
    const mintue = +this.minutes;
    const meridiem = this.meridien;

    const newHourValue = this.getValue(hour, mintue, meridiem);

    if (newHourValue >= hourLowerValue && newHourValue <= hourUpperValue) {
      hour = this.getHour(newHourValue);
      this.hourValue = hour;
      this.minuteValue = this.getMinute(newHourValue);
      this.meridien = this.getMeridiem(newHourValue);
      result = true;
    }

    return result;

  }


  addMinute() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    const step = this.minInterval && this.minInterval > 0 ? this.minInterval : 1;

    if (this.meridien === 'AM' && this.hourValue === 12) {
      this.hourValue = 0;
    }

    let minute = this.minuteValue + step;
    let hour = this.hourValue;
    let meridien = this.meridien;

    if (minute >= 60) {
      minute = minute - 60;
      if (meridien === 'AM' && hour === 11) {
        hour = 12;
        meridien = 'PM';
      } else if (meridien === 'PM' && hour === 12) {
        hour = 1;
      } else {
        hour = hour + 1;
      }
    }

    let newMinuteValue = this.getValue(hour, minute, meridien);

    if (newMinuteValue > hourUpperValue) {
      newMinuteValue = hourUpperValue;
      if (step > 1) {
        newMinuteValue = newMinuteValue - (newMinuteValue % step);
      }
    }

    if (newMinuteValue < hourLowerValue) {
      newMinuteValue = hourLowerValue;
      if (step > 1) {
        const remainder = newMinuteValue % step;
        newMinuteValue = remainder === 0 ? newMinuteValue : newMinuteValue + (step - remainder);
      }
    }

    if (newMinuteValue >= hourLowerValue && newMinuteValue <= hourUpperValue) {
      this.hourValue = this.getHour(newMinuteValue);
      this.minuteValue = this.getMinute(newMinuteValue);
      this.meridien = this.getMeridiem(newMinuteValue);
    }
  }

  reduceMinute() {
    const hourUpperValue = this.getValue(this.maxHour, this.maxMinute, null);
    const hourLowerValue = this.getValue(this.minHour, this.minMinute, null);
    const step = this.minInterval && this.minInterval > 0 ? this.minInterval : 1;

    if (this.meridien === 'AM' && this.hourValue === 12) {
      this.hourValue = 0;
    }

    let minute = this.minuteValue - step;
    let hour = this.hourValue;
    let meridien = this.meridien;

    if (minute < 0) {
      minute = 60 + minute;
      if (meridien === 'PM' && hour === 12) {
        hour = 11;
        meridien = 'AM';
      } else if (meridien === 'PM' && hour === 1) {
        hour = 12;
      } else {
        hour = hour - 1;
      }
    }

    let newMinuteValue = this.getValue(hour, minute, meridien);

    if (newMinuteValue < hourLowerValue) {
      newMinuteValue = hourLowerValue;
      if (step > 1) {
        const remainder = newMinuteValue % step;
        newMinuteValue = remainder === 0 ? newMinuteValue : newMinuteValue + (step - remainder);
      }
    }

    if (newMinuteValue > hourUpperValue) {
      newMinuteValue = hourUpperValue;
      if (step > 1) {
        newMinuteValue = newMinuteValue - (newMinuteValue % step);
      }
    }

    if (newMinuteValue >= hourLowerValue && newMinuteValue <= hourUpperValue) {
      this.hourValue = this.getHour(newMinuteValue);
      this.minuteValue = this.getMinute(newMinuteValue);
      this.meridien = this.getMeridiem(newMinuteValue);
    }
  }

  getDisplayHour() {
    if (this.hourValue === 0) {
      return '12';
    }
    if (this.hourValue < 10) {
      return '0' + this.hourValue.toString();
    }
    else {
      return this.hourValue.toString();
    }
  }
  getDisplayHourKeyPad(hour) {
    if (hour < 10) {
      return '0' + hour.toString();
    }
    else {
      return hour.toString();
    }
  }

  getDisplayMinuteKeyPad(minute) {
    if (minute < 10) {
      return '0' + minute.toString();
    }
    else {
      return minute.toString();
    }

  }

  getDisplayMinute() {
    if (this.minuteValue < 10) {
      return '0' + this.minuteValue.toString();
    }
    else {
      return this.minuteValue.toString();
    }

  }

  done() {
    if (this.showKeypad) {
      this.set();
    }
    else {
      this.normalizeSelectionToInterval();
      this.modalRef.dismiss({ hour: this.hourValue, minute: this.minuteValue, meridien: this.meridien, midnightSelected: this.midnightSelected }, 'done');
    }
  }

  close() {
    this.modalRef.dismiss(undefined, 'cancel');
  }


  add(num: number) {

    if (this.cnt === 4) {
      this.hoursnew = `000${num}`;
      this.cnt = 1;
    }
    else {
      this.cnt++;
      this.hoursnew = `${this.hoursnew}${num}`;

    }

    this.hoursnew = this.hoursnew.substring(this.hoursnew.length - 4, this.hoursnew.length);
    this.hours = this.hoursnew.substring(0, 2);
    this.minutes = this.hoursnew.substring(2, 4);

    // Only validate when all 4 digits have been entered
    if (this.cnt === 4) {
      if (+this.hours > 12) {
        this.error = 'Invalid Time';
        return;
      } else if (+this.minutes > 59) {
        this.error = 'Invalid Time';
        return;
      }
    }
    this.error = null;

  }

  reset(num) {
    this.hours = '00';
    this.minutes = '00';
    this.selectedField = null;
    this.error = null;
  }

  set() {
    if (this.validateKeyboardOutput() && this.error == null) {
      this.addInterval();
      this.modalRef.dismiss({ hour: this.hourValue, minute: this.minuteValue, meridien: this.meridien, midnightSelected: this.midnightSelected }, 'done');
    }
    else {
      this.error = 'Invalid Time';

    }
  }

  addInterval() {
    this.normalizeSelectionToInterval();
  }

  private normalizeSelectionToInterval() {
    if (!this.minInterval || this.minInterval <= 1) {
      return;
    }

    const remainder = this.minuteValue % this.minInterval;
    if (remainder > 0) {
      // Round to nearest interval instead of always flooring
      if (remainder >= this.minInterval / 2) {
        // Round up
        this.minuteValue = this.minuteValue + (this.minInterval - remainder);
      } else {
        // Round down
        this.minuteValue = this.minuteValue - remainder;
      }
    }

    const newHourValue = this.getValue(this.hourValue, this.minuteValue, this.meridien);
    this.hourValue = this.getHour(newHourValue);
    this.minuteValue = this.getMinute(newHourValue);
    this.meridien = this.getMeridiem(newHourValue);
  }

  execMethod(dial) {
    this[dial.method](dial.number);
  }

  toggle(dial = null) {
    if (this.midnightSelected) {
      return;
    }

    this.showKeypad = !this.showKeypad;
  }

  handleMidnightChange(event: any) {
    this.midnightSelected = event.detail.checked;
    if (this.midnightSelected) {
      this.hourValue = 0;
      this.minuteValue = 0;
      this.meridien = 'AM';
    } else {
      this.hourValue = this.maxHour > 12 ? this.maxHour - 12 : this.maxHour;
      this.minuteValue = this.maxMinute;
      this.meridien = this.maxTimeMeridien;
      this.normalizeSelectionToInterval();
    }
  }
}
